export default __webpack_public_path__ + "static/media/section3_3_2.cbe7052e.png";